export const API_HOST =
  process.env.REACT_APP_API_HOST || "https://dab-dshop-be.ddev.site";
export const SIGNUP_URL =
  process.env.REACT_APP_SIGNUP_URL ||
  "https://sso.dabpumps.com/%LANG/register?app=dshop";
export const EDIT_PROFILE_URL =
  process.env.REACT_APP_EDIT_PROFILE_URL ||
  "https://sso.dabpumps.com/%LANG/edit-profile";

export const LOGIN_URL = `${API_HOST}/sso/login`;
export const LOGOUT_URL = `${API_HOST}/sso/logout`;
export const GET_NAME = `${API_HOST}/sso/user-data`;
export const GET_PROVINCES = `${API_HOST}/dshop_addresses/provinces`;

export const ADD_ELEMENT = `${API_HOST}/add-line-item-to-cart`;
export const REMOVE_ELEMENT = `${API_HOST}/remove-line-item-to-cart`;

export const GETPDF = `${API_HOST}/generate-simulated-pdf`;

export const SEARCH_ADDRESS = `${API_HOST}/dshop_order/loadCustomers`;
export const LAST_ADDRESS = `${API_HOST}/dshop_order/getStartupAddresses`;
export const PERFORM_ORDER = `${API_HOST}/dshop_order/perform_order`;
export const GETBASKETS = `${API_HOST}/dshop_basket`;
export const GETAGENTID = `${API_HOST}/dshop_agent_basket`;

export const GETORDERS = `${API_HOST}/dshop-orders`;

export const GTM_ID = process.env.REACT_APP_GTM_ID;



// WEBPACK FOOTER //
// ./src/utils/constants.js